<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive" />
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
  </div>
</template>

<script>
// import eruda from 'eruda';
export default {
  name: 'App',
  beforeMount() {
    // eruda.init();
    // import('eruda').then((eruda) => {
    //   eruda.default.init();
    // });
  }
};
</script>

<style>
@import 'assets/css/common.css';
@import 'assets/css/demo1.css';
@import 'assets/font/font.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  height: auto;
}
.main-color {
  color: #db303c;
}
.main-bg-color {
  background: #db303c;
}
img {
  object-fit: cover;
}
.sticky {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  padding: 10px 0;
  z-index: 9;
}
.picture-sticky {
  position: sticky;
  top: 45px;
  background-color: #ffffff;
  z-index: 2;
}
</style>
